import React from 'react';

const Card = ({ children }) => {
  return (
    <div className="card" style={{ border: '1px solid #ddd', padding: '16px', borderRadius: '8px' }}>
      {children}
    </div>
  );
};

export const CardContent = ({ children }) => (
  <div className="card-content" style={{ marginTop: '16px' }}>
    {children}
  </div>
);

export default Card;
